module.exports = ":host{display:inline-block;overflow:hidden;vertical-align:top}:host,svg{height:var(--lui-line-height);width:var(--lui-line-height)}svg{transition:var(--lui-transitions-default)}:host([paused]) svg{opacity:0;transform:scale(.5)}svg>g{animation-duration:.7s;animation-iteration-count:infinite;animation-name:a}@keyframes a{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-spinner/theme/lui-spinner.scss
// module id = 320
// module chunks = 0 1 26